import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseApi = () => {
    function queryCustomerContact(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/web/customer/queryCustomerContact`, data);
    }

    function queryCustomerQaGroup(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/web/customer/queryCustomerQaGroup`, data);
    }

    function queryCustomerQa(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/web/customer/queryCustomerQa`, data);
    }

    return {
        queryCustomerContact,
        queryCustomerQaGroup,
        queryCustomerQa
    };
};

export const customerApi = baseApi();
